import { useLayoutEffect, useState } from 'react';

// The app intentionally zooms <html> on desktop. Floating UI positions portals
// in visual viewport pixels; zooming those coordinates again offsets them.
// Neutralise zoom only on these voice popup wrappers, never the global layout.
export const useVoicePopupRef = () => {
  const [node, setNode] = useState(null);
  useLayoutEffect(() => {
    if (!node) return undefined;
    const wrapper = node.closest('[data-radix-popper-content-wrapper]');
    if (!wrapper) return undefined;
    const original = wrapper.style.zoom;
    const sync = () => {
      const zoom = Number.parseFloat(getComputedStyle(document.documentElement).zoom) || 1;
      wrapper.style.zoom = String(1 / zoom);
    };
    sync();
    window.addEventListener('resize', sync);
    const observer = new MutationObserver(sync);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'style'] });
    return () => { window.removeEventListener('resize', sync); observer.disconnect(); wrapper.style.zoom = original; };
  }, [node]);
  return setNode;
};